export default __webpack_public_path__ + "static/media/Wall_Conveyor_x1_Grey.256.4400e3a1.png";